import { css } from '@emotion/react'

export const filtersWrapper = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
`
